module.exports = __webpack_public_path__ + "media/images/comment_ic-ffef2fa53323397798d179d0eebf43de.svg";